/**
 * Short notes for the editor's debug overlay (editorDebug=1), such as a
 * refused play() (spec 13.8). Kept in memory, the last six; also logged to the
 * console. Nothing is shown unless the overlay is on.
 */
const notes: string[] = [];

export function debugNote(message: string): void {
  notes.push(`${new Date().toISOString().slice(11, 19)} ${message}`);
  if (notes.length > 6) notes.shift();
  console.warn('[editor]', message);
}

export function debugNotesSnapshot(): string[] {
  return notes.slice();
}
